import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';


import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { NavbarComponent } from './components/navbar/navbar.component';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MaterialModule } from './material/material.module';

import { AuthService } from './services/auth.service';
import { ApicallService } from './services/apicall.service';
import { ValidateService } from './services/validate.service';

import { FormsModule } from '@angular/forms';

import { FlashCustomComponent } from './components/flash-custom/flash-custom.component';
import { FlashService } from './services/flash.service';
import { PermissionService } from './services/permission.service';
import { PermissionGuard } from './guards/permission.guard';

import { catchError, retry } from 'rxjs/operators';

import { PdfViewerModule, PdfViewerComponent  } from 'ng2-pdf-viewer';
import { TaxFormatPipe } from './pipe/tax-format.pipe';

@NgModule({
    declarations: [AppComponent, NavbarComponent, SideNavComponent, TaxFormatPipe],
    imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule, BrowserAnimationsModule, HttpClientModule, MaterialModule, FormsModule, FlashCustomComponent, PdfViewerModule, FlexLayoutModule],
    providers: [
        StatusBar,
        SplashScreen,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        AuthService,
        ValidateService,
        FlashService,
        ApicallService,
        PermissionService,
        PermissionGuard,
        PdfViewerComponent,
        TaxFormatPipe
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
